<div class="sophia-app app" [ngClass]="settings.theme" id="mainDIV" style="height: 100vh;overflow: auto;">
    <app-sidebar-summary-cart></app-sidebar-summary-cart>
    <app-main></app-main>
   
    <app-my-loader></app-my-loader>
   
</div>

